var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "balanceRecord page-container" },
    [
      _c("div", { staticClass: "page-title" }, [
        _c(
          "span",
          {
            staticStyle: { cursor: "pointer" },
            on: {
              click: function ($event) {
                return _vm.$router.push({ name: "Merchant_List" })
              },
            },
          },
          [
            _c("i", { staticClass: "el-icon-back" }),
            _vm._v(" " + _vm._s(_vm.$route.params.merchant_name) + " "),
          ]
        ),
      ]),
      _c(
        "div",
        { staticClass: "page-card" },
        [
          _c("svg-icon", {
            attrs: { "icon-class": "transaction_records_icon" },
          }),
          _c("span", { staticStyle: { "margin-left": "14px" } }, [
            _vm._v(_vm._s(_vm.$t("menu.transaction_records"))),
          ]),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        _vm._l(_vm.componentConfig, function (item, index) {
          return _c("el-tab-pane", {
            key: index,
            attrs: { label: item.label, name: item.compName },
          })
        }),
        1
      ),
      _c(_vm.activeName, { key: _vm.activeName, tag: "component" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }